import { gsap } from 'gsap'
import { Draggable } from 'gsap/Draggable'
import { throttle } from 'lodash-es'

gsap.registerPlugin(Draggable)

const setupGallery = (el) => {
  const container = el.querySelector('[data-container]')
  const prevBtn = el.querySelector('[data-prev]')
  const nextBtn = el.querySelector('[data-next]')
  const counter = el.querySelector('[data-counter]')
  const items = el.querySelectorAll('li')
  const cursor = el.querySelector('[data-cursor]')
  const cursorIcon = el.querySelector('[data-icon]')

  let prevRect = null
  let nextRect = null
  let draggable = null

  let current = items.length - 1
  let currentSlide = items[current]
  let animating = false
  let count = 1

  function prev() {
    if (!animating) {
      if (current > 0) {
        current--
      } else {
        current = items.length - 1
      }

      count = count > 1 ? count - 1 : items.length

      gsap
        .timeline({ defaults: { duration: 1, ease: 'expo.inOut' } })
        .to(currentSlide, {
          xPercent: 50,
          duration: 0.75,
        })
        .fromTo(
          items[current],
          {
            xPercent: -100,
          },
          {
            xPercent: 0,
            duration: 0.75,
          },
          0,
        )
        .eventCallback('onStart', () => {
          animating = true
          gsap.set(items, { zIndex: 0 })
          gsap.set(currentSlide, { zIndex: 1 })
          gsap.set(items[current], { zIndex: 2 })

          window.requestAnimationFrame(() => {
            updateCounter()
          })
        })
        .eventCallback('onComplete', () => {
          animating = false
          currentSlide = items[current]
        })
    }
  }

  function next() {
    if (!animating) {
      if (current < items.length - 1) {
        current++
      } else {
        current = 0
      }

      count = count < items.length ? count + 1 : 1

      gsap
        .timeline({ defaults: { duration: 1, ease: 'expo.inOut' } })
        .to(currentSlide, {
          xPercent: -50,
          duration: 0.75,
        })
        .fromTo(
          items[current],
          {
            xPercent: 100,
          },
          {
            xPercent: 0,
            opacity: 1,
            duration: 0.75,
          },
          0,
        )
        .eventCallback('onStart', () => {
          animating = true

          gsap.set(items, { zIndex: 0 })
          gsap.set(currentSlide, { zIndex: 1 })
          gsap.set(items[current], { zIndex: 2 })

          window.requestAnimationFrame(() => {
            updateCounter()
          })
        })
        .eventCallback('onComplete', () => {
          animating = false
          currentSlide = items[current]
        })
    }
  }

  function updateCounter() {
    gsap
      .timeline({ defaults: { duration: 0.375 } })
      .to(counter, {
        y: 16,
        opacity: 0,
        ease: 'power2.in',
        onComplete: () => {
          window.requestAnimationFrame(() => {
            counter.innerHTML = count < 10 ? `0${count}` : `${count}`
          })
        },
      })
      .fromTo(
        counter,
        {
          y: -16,
          opacity: 0,
        },
        {
          y: 0,
          opacity: 1,
          ease: 'power2.out',
          immediateRender: false,
        },
      )
  }

  function showCursor() {
    gsap.fromTo(
      cursor,
      {
        scale: 0.5,
        opacity: 0,
      },
      {
        scale: 1,
        opacity: 1,
        duration: 0.25,
        ease: 'power2.out',
      },
    )
  }

  function hideCursor() {
    gsap.to(cursor, {
      opacity: 0,
      scale: 0.5,
      duration: 0.25,
      ease: 'power2.out',
    })
  }

  function updateCursor(evt) {
    if (prevRect !== null && nextRect !== null) {
      if (evt.target == nextBtn) {
        gsap.set(cursorIcon, {
          rotate: 0,
        })

        gsap.set(cursor, {
          x: evt.offsetX + prevRect.width,
          y: evt.offsetY,
        })
      } else {
        gsap.set(cursorIcon, {
          rotate: 180,
        })

        gsap.set(cursor, {
          x: evt.offsetX,
          y: evt.offsetY,
        })
      }
    }
  }

  function setupDraggable() {
    draggable = Draggable.create(document.createElement('div'), {
      trigger: container,
      type: 'x',
      minimumMovement: 10,
      onDragStart: function () {
        const direction = this.getDirection()

        if (direction === 'left') {
          next()
        }

        if (direction === 'right') {
          prev()
        }
      },
    })
  }

  function killDraggrable() {
    if (draggable !== null) {
      draggable.kill()
      draggable == null
    }
  }

  function onResize() {
    prevRect = prevBtn.getBoundingClientRect()
    nextRect = nextBtn.getBoundingClientRect()

    if (window.innerWidth >= 768 && draggable !== null) {
      killDraggrable()
    }

    if (window.innerWidth < 768 && draggable === null) {
      setupDraggable()
    }
  }

  function init() {
    prevBtn.addEventListener('click', prev, false)
    nextBtn.addEventListener('click', next, false)

    container.addEventListener('mousemove', updateCursor, false)
    container.addEventListener('mouseenter', showCursor, false)
    container.addEventListener('mouseleave', hideCursor, false)

    window.addEventListener('resize', throttle(onResize, 100), false)

    gsap.set(cursor, {
      rotate: 0,
    })

    window.requestAnimationFrame(() => {
      prevRect = prevBtn.getBoundingClientRect()
      nextRect = nextBtn.getBoundingClientRect()

      if (window.innerWidth < 768) {
        setupDraggable()
      }
    })
  }

  init()
}

export default setupGallery
